import { Component, Input } from '@angular/core';
import { ICellRendererParams } from "ag-grid-community";
import { AlertStatus } from '@models/alerts/alerts-enums';
import { SplitByCapitalLetterPipePipe } from "../../../../../../shared/pipes/split-by-capital-letter-pipe.pipe";
import { formatDate } from "@angular/common";
import { AlertsStatusPipe } from "../../../../../../shared/pipes/alertsStatusPipe";
import { Alert } from "../../../../../../models/alerts/alert";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { AuTimePipe } from "../../../../../../shared/pipes/au-time.pipe";

type CellRendererParams = ICellRendererParams<Alert, AlertStatus>;

@Component({
  selector: 'app-ag-alerts-status',
  standalone: true,
  imports: [
    SplitByCapitalLetterPipePipe,
    AlertsStatusPipe,
    NgbTooltip,
  ],
  templateUrl: 'ag-alerts-status.component.html',
  styleUrl: 'ag-alerts-status.component.scss'
})
export class AgAlertsStatusComponent implements ICellRendererAngularComp {
  @Input() status: AlertStatus | undefined | null;
  @Input() postponedTill?: Date | string;
  @Input() isRead = false;

  readonly AlertStatus = AlertStatus;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.status = params.value;
    this.isRead = params.data?.isRead ?? false;
    this.postponedTill = params.data?.postponedTill;

    return true;
  }

  get postponedTillMessage(): string {
    const postponedTill = this.postponedTill;
    const postponedTillAu = AuTimePipe.formatValue(postponedTill);

    return postponedTill && postponedTillAu
      ? `Postponed until ${ formatDate(postponedTillAu, 'dd MMM yyyy', 'en') }`
      : '';
  }
}
